// react-leaflet-draw ESM does `import { PropTypes } from 'prop-types'` (invalid named import).
// This shim re-exports the CJS default as a named `PropTypes` export so the import resolves.
import PropTypes from '../../node_modules/prop-types/index.js';
export { PropTypes };
export default PropTypes;
